import {
  defineNuxtPlugin,
  toPublicPath,
  useCookie,
  useRoute,
  useRuntimeConfig,
  useScript,
} from '#imports'
import { watch } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useIsE2ETestingEnvironment } from '@backmarket/nuxt-module-qa/useIsE2ETestingEnvironment'

const CONSTRUCTOR_SCRIPT_URL = '/vendor/constructor-beacon.js'
const CONSTRUCTOR_SCRIPT_INTEGRITY =
  'sha384-A7889qcwb0eFlscm0oM6vp8zvq9wMB0KH5Jj9vlBGun0qSW62kFrfAU38Xyp/gCX'

export default defineNuxtPlugin(() => {
  if (useIsE2ETestingEnvironment()) return

  const { market } = useMarketplace()
  const { FF_CONSTRUCTOR_ENABLED } = useRuntimeConfig().public
  const experiments = useExperiments()

  if (
    market.countryCode !== MarketCountryCode.US ||
    (!FF_CONSTRUCTOR_ENABLED &&
      experiments['experiment.constructor'] !== 'enabled')
  ) {
    return
  }

  const disableBeacon = useCookie<boolean | undefined>(
    'ConstructorioDisableBeaconTracking',
    {
      maxAge: undefined,
      path: '/',
    },
  )

  const route = useRoute()

  watch(
    () => route.meta.auth?.required || false,
    (isRequired) => {
      disableBeacon.value = isRequired ? true : undefined
    },
    { immediate: true },
  )

  useScript(
    {
      defer: true,
      id: 'constructor-io',
      src: toPublicPath(CONSTRUCTOR_SCRIPT_URL),
      integrity: CONSTRUCTOR_SCRIPT_INTEGRITY,
      crossorigin: 'anonymous',
    },
    { trigger: 'onNuxtReady' },
  )
})
